<template>
	<v-container fluid>
		<v-expansion-panels class="mb-6" :value="0">
			<v-expansion-panel>
				<v-expansion-panel-header disable-icon-rotate>
					Critérios de pesquisa
					<template v-slot:actions>
						<v-icon>search</v-icon>
					</template>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-layout wrap>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.ano_lectivo" label="Ano Lectivo" :items="AnosLectivos" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm8 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.concelho_id" label="Concelho" :items="Concelhos" :clearable="Concelhos.length > 1" :readonly="Concelhos.length == 1"></v-select>
						</v-flex>
						<v-flex xs12 sm4 md4 px-1>
							<v-text-field v-model="Pesquisa.Criterios.escola_nome" label="Nome da escola" clearable></v-text-field>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.turma_ano" label="Ano" :items="AnosCurriculares" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-text-field v-model="Pesquisa.Criterios.turma_designacao" label="Turma" clearable></v-text-field>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 sm8 md4 px-1>
							<v-text-field v-model="Pesquisa.Criterios.aluno_nome" label="Nome do aluno" clearable></v-text-field>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_sexo" label="Sexo" :items="Sexos" clearable></v-select>
						</v-flex>
					</v-layout>
					<v-layout wrap>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_transferido" label="Transferido?" :items="NaoSim" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_nee" label="NEE?" :items="NaoSim" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_feo" label="FEO?" :items="NaoSim" clearable></v-select>
						</v-flex>
						<v-flex xs12 sm4 md2 px-1>
							<v-select v-model="Pesquisa.Criterios.aluno_medida_apoio" label="Medida de apoio?" :items="NaoSim" clearable></v-select>
						</v-flex>
					</v-layout>

					<div class="my-8">
						<v-layout d-flex justify-end>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text color="primary" v-on="on" @click="pesquisar">
										<v-icon left>search</v-icon>
										Pesquisar
									</v-btn>
								</template>
								<span>Pesquisar</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text color="primary" v-on="on" @click="limpar">
										<v-icon left>clear</v-icon>
										Limpar
									</v-btn>
								</template>
								<span>Limpar critérios de pesquisa</span>
							</v-tooltip>
						</v-layout>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-data-table
			:headers="Pesquisa.Colunas"
			:items="Pesquisa.Resultados"
			:items-per-page="10"
			:loading="Pesquisa.estado === 1" loading-text="A carregar... Por favor aguarde..."
			multi-sort
			:footer-props="{
				showFirstLastPage: true,
				//itemsPerPageText: 'asd'
			}"
			class="elevation-1">
			<template v-slot:no-data>
				{{ Pesquisa.estado === 2 ? "Não foram encontrados alunos." : "Defina os critérios pretendidos e clique em 'Pesquisar'." }}
			</template>
			<template v-slot:item.turma_designacao="{ item }">
				{{ item.turma_ano }}.º {{ item.turma_designacao }}
			</template>
			<template v-slot:item.aluno_transferido="{ item }">
				{{ item.aluno_transferido ? 'Sim' : '' }}
			</template>
			<template v-slot:item.aluno_nee="{ item }">
				{{ item.aluno_nee ? 'Sim' : '' }}
			</template>
			<template v-slot:item.aluno_feo="{ item }">
				{{ item.aluno_feo ? 'Sim' : '' }}
			</template>
			<template v-slot:item.aluno_medida_apoio="{ item }">
				{{ item.aluno_medida_apoio ? 'Sim' : '' }}
			</template>
		</v-data-table>
	</v-container>
</template>

<script>
    import Vue from 'vue'
	import StaticData from '@/data/static-data.js';
	Vue.use(StaticData);

	import UserService from '@/services/user.service';
	const userService = new UserService();

	export default {
		data: () => ({
			AnosLectivos: StaticData.AnosLectivos,
			Concelhos: [], // to be loaded on created
			AnosCurriculares: StaticData.AnosCurriculares,
			Sexos: StaticData.Sexos,
			NaoSim: StaticData.NaoSim,
			Pesquisa: {
				estado: 0, /* 0 - Por efectuar; 1 - Em processamento; 2 - Efectuada*/
				Criterios: {
					ano_lectivo: StaticData.AnoLectivoActual
				},
				Colunas: [
					{ text: 'Ano Lectivo', value: 'ano_lectivo_desc' },
					{ text: 'Freguesia', value: 'freguesia_nome' },
					{ text: 'Escola', value: 'escola_nome' },
					{ text: 'Turma', value: 'turma_designacao' },
					{ text: 'Nome', value: 'aluno_nome', align: 'left' },
					{ text: 'Número', value: 'aluno_numero', align: 'center' },
					{ text: 'Transferido?', value: 'aluno_transferido', sortable: false },
					{ text: 'NEE?', value: 'aluno_nee', sortable: false },
					{ text: 'FEO?', value: 'aluno_feo', sortable: false },
					{ text: 'Medida de Apoio?', value: 'aluno_medida_apoio', sortable: false },
				],
				Resultados: []
			}
		}),

        created () {
			this.loadConcelhos();
        },

		computed: {
			QueryPesquisa: function () {
				let queryPesquisa = 
					(this.Pesquisa.Criterios.ano_lectivo ? `&ano_lectivo_id=${this.Pesquisa.Criterios.ano_lectivo}` : '') +
					(this.Pesquisa.Criterios.concelho_id ? `&concelho_id=${this.Pesquisa.Criterios.concelho_id}` : '') +
					(this.Pesquisa.Criterios.escola_nome ? `&escola_nome=${this.Pesquisa.Criterios.escola_nome}` : '') +
					(this.Pesquisa.Criterios.turma_ano ? `&turma_ano=${this.Pesquisa.Criterios.turma_ano}` : '') +
					(this.Pesquisa.Criterios.turma_designacao ? `&turma_designacao=${this.Pesquisa.Criterios.turma_designacao}` : '') +
					(this.Pesquisa.Criterios.aluno_nome ? `&aluno_nome=${this.Pesquisa.Criterios.aluno_nome}` : '') +
					(this.Pesquisa.Criterios.aluno_sexo ? `&aluno_sexo=${this.Pesquisa.Criterios.aluno_sexo}` : '') +
					(this.Pesquisa.Criterios.aluno_transferido ? `&aluno_transferido=${this.Pesquisa.Criterios.aluno_transferido}` : '') +
					(this.Pesquisa.Criterios.aluno_nee ? `&aluno_nee=${this.Pesquisa.Criterios.aluno_nee}` : '') +
					(this.Pesquisa.Criterios.aluno_feo ? `&aluno_feo=${this.Pesquisa.Criterios.aluno_feo}` : '') +
					(this.Pesquisa.Criterios.aluno_medida_apoio ? `&aluno_medida_apoio=${this.Pesquisa.Criterios.aluno_medida_apoio}` : '')
				;

				if (queryPesquisa.length > 0) {
					queryPesquisa = queryPesquisa.replace('&', '?');
				}

				return queryPesquisa;
			}
        },

        methods: {
			loadConcelhos () {
				this.isLoading = true;

				var currentUser = userService.getUserId();

				this.$http.get(process.env.VUE_APP_API_ROOT + `/concelho/?utilizador=${currentUser}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    var arrayConcelhos = [];
                    data.forEach (item => {
                        arrayConcelhos.push({ value: item.id, text: item.nome});
                    });
					this.Concelhos = arrayConcelhos;
					
					if (arrayConcelhos.length === 1) {
						this.Pesquisa.Criterios.concelho_id = arrayConcelhos[0].value;
					}

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
			pesquisar () {
				this.Pesquisa.estado = 1;

				this.$http.get(process.env.VUE_APP_API_ROOT + '/pesquisa-alunos' + this.QueryPesquisa).then(function(data){
                    return data.json();
                }).then(function(data){
                    // console.log(data);
                    this.Pesquisa.Resultados = data;

					this.Pesquisa.estado = 2;
                }, response => { // error callback
					this.Pesquisa.estado = 2;
				});
			},
			limpar () {
				this.Pesquisa.Criterios = {
					ano_lectivo: StaticData.AnoLectivoActual
				};
				if (this.Concelhos.length === 1) {
					this.Pesquisa.Criterios.concelho_id = this.Concelhos[0].value;
				};
				this.Pesquisa.estado = 0;
				this.Pesquisa.Resultados = [];
			}
		}
	}
</script>